import { LocaleCode } from "../typings/lang";

export const postMessageToV2 = ({
    saleId,
    selectedTargetLanguage
}: {
    saleId: any;
    selectedTargetLanguage?: LocaleCode;
}) => {
    saleId = parseInt(saleId, 10);
    const iframe = document.querySelector(".iframe-container iframe") as HTMLIFrameElement;
    iframe?.contentWindow.postMessage({ saleId, selectedTargetLanguage }, window.location.origin);
};
